// How dates, numbers and errors are shown on screen.

/** 2026-10-24T10:00:00+05:30 -> 2026-10-24 10:00 (the portal is always in IST, so no zone is shown). */
export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—'
  return value.slice(0, 10) + ' ' + value.slice(11, 16)
}

export function formatNumber(value: number): string {
  return value.toLocaleString('en-IN')
}

/** "3 of 2000 (0%)" style share, rounded. */
export function formatShare(part: number, whole: number): string {
  if (!whole) return '—'
  return Math.round((part * 100) / whole) + '%'
}

/** The message of any error the API throws (ApiError carries a plain-English message). */
export function errorText(error: unknown): string {
  if (error instanceof Error) return error.message
  return 'Something went wrong.'
}

/** 0 / 950 / 1.2K / 30.6K, for chart axes (exact numbers stay in tables and tooltips). */
export function formatCompact(value: number): string {
  if (value < 1000) return String(value)
  const thousands = value / 1000
  return (thousands < 10 ? thousands.toFixed(1).replace(/\.0$/, '') : Math.round(thousands)) + 'K'
}

/** 2026-10-24 -> Sat 24 Oct */
export function formatDay(date: string): string {
  const day = new Date(date + 'T00:00:00Z')
  return day.toLocaleDateString('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
  })
}
